module.exports = __webpack_public_path__ + "img/ticket.b1dd1208.svg";